import Vue from 'vue'
import VueRouter from 'vue-router'
import layouts from './components/Layout/index.vue'

Vue.use(VueRouter)

export const constantRoutes = [ // 基础
  {
    path: '/',
    name: 'dashboard',
    component: layouts,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('./pages/dashboard/index.vue'),
        meta: { title: '总览', keepAlive: true }
      }
    ]
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('./pages/NotFound.vue')
  }

  // { path: '/template/create', component: createTemplate },
  // { path: '/template/edit/:id', component: createTemplate },
  // { path: '/groupMessage', name: 'groupMessage', component: groupMessage },
  // { path: '/detection', component: detection },
  // { path: '/statement', component: statement },
  // { path: '/settings', component: settings },
  // { path: '*', component: NotFound }
]

export const asyncRoutes = [
  {
    path: '/solutor',
    name: 'solutor',
    component: layouts,
    redirect: '/solutor/templates',
    meta: { title: '报备中心' },
    children: [
      {
        path: 'signature',
        name: 'signature',
        component: () => import('./pages/solutor/signature'),
        meta: { title: '签名' }
      },
      {
        path: 'signature/create',
        name: 'createSignature',
        component: () => import('./pages/solutor/createSignature'),
        hidden: true
      },
      {
        path: 'signature/edit/:id',
        name: 'editSignature',
        component: () => import('./pages/solutor/createSignature'),
        hidden: true
      },
      {
        path: 'templates',
        name: 'templates',
        component: () => import('./pages/solutor/templates'),
        meta: { title: '模板' }
      },
      {
        path: 'templates/create',
        name: 'create',
        component: () => import('./pages/solutor/createTemplate'),
        hidden: true
      },
      {
        path: 'template/edit/:id',
        name: 'edit',
        component: () => import('./pages/solutor/createTemplate'),
        hidden: true
      },
      {
        path: 'database',
        name: 'database',
        component: () => import('./pages/solutor/database'),
        meta: { title: '报备资料' }
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: layouts,
    redirect: '/message/groupMessage',
    meta: { title: '短信发送' },
    children: [
      {
        path: 'groupMessage',
        name: 'groupMessage',
        component: () => import('./pages/message/groupMessage'),
        meta: { title: '页面发送' }
      },
      {
        path: 'groupApi',
        name: 'groupApi',
        component: () => import('./pages/message/groupApi'),
        meta: { title: 'API 发送' }
      }
    ]
  },
  // {
  //   path: '/advanced',
  //   name: 'advanced',
  //   component: layouts,
  //   meta: { title: '高级功能' },
  //   children: [
  //     {
  //       path: 'detection',
  //       name: 'detection',
  //       component: () => import('./pages/advanced/detection'),
  //       meta: { title: '空号检测' }
  //     }
  //   ]
  // },
  {
    path: '/report',
    name: 'report',
    component: layouts,
    redirect: '/report/inHttp',
    meta: { title: '报表' },
    children: [
      {
        path: 'inCmpp',
        name: 'cmpp',
        component: () => import('./pages/report/index'),
        meta: {
          title: 'cmpp',
          roles: ['cmpp']
        },
        children: [
          {
            path: 'cmppOverview',
            name: 'cmppOverview',
            component: () => import('./pages/report/cmpp/overview'),
            meta: { title: '总览' }
          },
          {
            path: 'cmppDetail',
            name: 'cmppDetail',
            component: () => import('./pages/report/cmpp/details'),
            meta: { title: '明细' }
          },
          {
            path: 'cmppAnalysis',
            name: 'cmppAnalysis',
            component: () => import('./pages/report/cmpp/analysis'),
            meta: { title: '失败分析' }
          },
          {
            path: 'cmppState',
            name: 'cmppState',
            component: () => import('./pages/report/cmpp/cmppStatement'),
            hidden: true
          }
        ]
      },
      {
        path: 'inHttp',
        name: 'http',
        component: () => import('./pages/report/index'),
        redirect: '/report/inHttp/overview',
        meta: { title: 'http' },
        children: [
          {
            path: 'httpOverview',
            name: 'httpOverview',
            component: () => import('./pages/report/http/overview'),
            meta: { title: '总览' }
          },
          {
            path: 'httpDetail',
            name: 'httpDetail',
            component: () => import('./pages/report/http/details'),
            meta: { title: '明细' }
          },
          {
            path: 'httpAnalysis',
            name: 'httpAnalysis',
            component: () => import('./pages/report/http/analysis'),
            meta: { title: '失败分析' }
          },
          {
            path: 'detections',
            name: 'detections',
            component: () => import('./pages/report/http/detection'),
            meta: { title: '空号检测' }
          },
          {
            path: 'grouplist',
            name: 'grouplist',
            component: () => import('./pages/report/http/grouplist'),
            meta: { title: '群发列表' }
          },
          {
            path: 'httpState',
            name: 'httpState',
            component: () => import('./pages/report/http/httpStatement'),
            hidden: true
          }
        ]
      }
    ]
  },
  {
    path: '/config',
    name: 'config',
    component: layouts,
    redirect: '/config/settings',
    meta: { title: '配置中心' },
    children: [
      {
        path: 'settings',
        name: 'settings',
        component: () => import('./pages/config/settings'),
        meta: { title: '平台配置' }
      },
      {
        path: 'templateConfig',
        name: 'templateConfig',
        component: () => import('./pages/config/templateConfig'),
        meta: { title: '模板配置' }
      },
      {
        path: 'cmppConfig',
        name: 'cmppConfig',
        component: () => import('./pages/config/cmppConfig'),
        meta: {
          title: 'CMPP',
          roles: ['cmpp']
        }
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

global.antRouter = constantRoutes

const createRouter = () => new VueRouter({
  routes: constantRoutes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/routes.js